import { useTranslation } from 'react-i18next'
import clsx from 'clsx'
import PropTypes from 'prop-types'

import Btn from '../../../../../UI/Btn'
import VisibilityAccess from '../../../../VisibilityAccess'
import { TRoles } from '../../../../../shared/const'
import { ShieldCheckIcon } from './personIcons'

import styles from '../style.module.scss'

/**
 * Abschnitt „Kontaktdaten" in den Basisinformationen: E-Mail-Adresse des
 * Unternehmens (samt Bestaetigung und Aenderung durch die Verwaltung) und
 * Telefon. Website, soziale Netzwerke und Logo stehen seit 08.08.2026 in den
 * Stammdaten darueber — sie sagen etwas ueber das Unternehmen aus, nicht
 * darueber, wie die Verwaltung es erreicht.
 *
 * Die Marke „bestaetigt / nicht bestaetigt" steht an der Feldbeschriftung, nicht
 * neben den Knoepfen: Sie sagt etwas ueber die Adresse aus, sie ist keine
 * Handlung. Sie bleibt deshalb auch in der Sicht der Lehrkraft (`readOnly`)
 * stehen — dort faellt nur weg, was eine Handlung waere.
 */
export default function ContactTab(props) {
	const { t } = useTranslation()
	const {
		companyInfo,
		readOnly,
		newEmailValue,
		setNewEmailValue,
		isEmailChanging,
		setIsEmailChanging,
		onSaveEmail,
		onVerifyBtnClick,
		isSendingEmailVerify
	} = props

	return (
		<section className={styles.block}>
			<h3 className={styles.blockTitle}>{t('Contact Details')}</h3>
			<div className={styles.fieldGrid}>
				<div className={clsx(styles.readOnlyInput, styles.fieldWide)}>
					<h3 className={styles.readOnlyLabel}>
						{t('Company email')}
						<span className={companyInfo?.emailVerified ? styles.verifyText : styles.nonVerifyText}>
							<ShieldCheckIcon className={styles.verifyIcon} />
							{companyInfo?.emailVerified ? t('Verified') : t('Not Verified')}
						</span>
					</h3>
					<div className={styles.fieldWithAction}>
						{!isEmailChanging ? (
							<div className={styles.readOnlyText}>{readOnly ? companyInfo?.email : newEmailValue}</div>
						) : (
							<input
								className={clsx(styles.input, styles.readOnlyText)}
								value={newEmailValue || ''}
								onChange={e => setNewEmailValue(e.target.value)}
								name="email_change"
							/>
						)}
						{!readOnly && (
							<div className={styles.fieldActions}>
								{!companyInfo?.emailVerified && (
									<Btn
										className={clsx(styles.btnVerify, styles.btnVerifyAccent)}
										iconClassName={styles.btnIconReset}
										loading={isSendingEmailVerify}
										type="button"
										icon="resend"
										iconOrder={0}
										iconSize={{ w: 19, h: 19 }}
										iconColor="#b06f00"
										onClick={onVerifyBtnClick}
									>
										{t('Verify_company_email_btn')}
									</Btn>
								)}
								<VisibilityAccess access={[TRoles.ADMIN, TRoles.FEDERAL_ADMIN]}>
									{companyInfo?.emailVerified ? (
										<Btn
											className={styles.btnVerify}
											iconClassName={styles.btnIconReset}
											loading={isSendingEmailVerify}
											type="button"
											icon={isEmailChanging ? 'save' : 'resend'}
											iconOrder={0}
											iconSize={{ w: 19, h: 19 }}
											iconColor="#008b9c"
											onClick={() => (isEmailChanging ? onSaveEmail() : setIsEmailChanging(true))}
										>
											{isEmailChanging ? t('save') : t('Update Email')}
										</Btn>
									) : (
										<></>
									)}
								</VisibilityAccess>
							</div>
						)}
					</div>
				</div>
				<div className={styles.readOnlyInput}>
					<h3 className={styles.readOnlyLabel}>{t('phone')}</h3>
					<div className={styles.readOnlyText}>
						{companyInfo?.phone || <span className={styles.emptyValue}>—</span>}
					</div>
				</div>
			</div>
		</section>
	)
}

ContactTab.propTypes = {
	companyInfo: PropTypes.object,
	readOnly: PropTypes.bool,
	newEmailValue: PropTypes.string,
	setNewEmailValue: PropTypes.func,
	isEmailChanging: PropTypes.bool,
	setIsEmailChanging: PropTypes.func,
	onSaveEmail: PropTypes.func,
	onVerifyBtnClick: PropTypes.func,
	isSendingEmailVerify: PropTypes.bool
}
